import { useStaticQuery, graphql } from "gatsby"

export const useCarnetAdresse = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allTaxonomyTermThematiques(
          filter: {
            relationships: {
              node__carnet_d_adresse: {
                elemMatch: { field_mise_en_avant: { eq: true } }
              }
            }
          }
        ) {
          edges {
            node {
              name
            }
          }
        }
        allNodeCarnetDAdresse(
          sort: { fields: field_ordre_carnet_d_adresse, order: DESC }
          filter: { field_mise_en_avant: { eq: true } }
        ) {
          ...ListAdresses
        }
        taxonomyTermZoneDefinie(name: { eq: "carnet_d_adresse" }) {
          ...AllCarnetTaxo
        }
      }
    `
  )
  return data
}

export const queryTaxo = graphql`
  fragment AllCarnetTaxo on taxonomy_term__zone_definie {
    field_label
    description {
      processed
    }
  }
`
